module.exports = __webpack_public_path__ + "static/desktop-stepper-platinum-icon-6a713c16015774e15e5397b77fb4b4af.svg";